module.exports = __webpack_public_path__ + "static/1-66c379103ab90d0f026f70690d8ff6f5.jpg";